import { secondsToHumanTime } from '@/utils/secondsToHumanTime';
import { KImage, KTag, KText } from '@/ui-library/components';
import { Flex, Link } from '@chakra-ui/react';

export const NameCell = (row) => {
  const { id, contact = {} } = row?.original?.ats_application || {};
  const { image_url, first_name, last_name } = contact || {};
  const { id: jobId } = row?.original?.ats_job || {};

  return (
    <>
      {first_name ? (
        <Link
          href={`/jobs/${jobId}?tab=candidates&appId=${id}`}
          target="_blank"
          w="100%"
          display="flex"
          alignItems="center"
          gap="6px"
        >
          <KImage
            name={`${first_name} ${last_name}`}
            src={image_url}
            backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
          />

          <KText
            maxW="100%"
            enableTooltip={true}
            isTruncated
            size="sm-regular"
            _hover={{
              textDecoration: 'underline',
              color: 'primary-500',
              cursor: 'pointer',
            }}
            textTransform="capitalize"
          >
            {`${first_name || ''} ${last_name || ''}`}
          </KText>
        </Link>
      ) : (
        '-'
      )}
    </>
  );
};

export const TimeToOffer = (row) => {
  const { time_to_offer } = row?.original || {};
  return <KText>{secondsToHumanTime(time_to_offer)}</KText>;
};

export const OfferStatus = (row) => {
  const { offer_status = '' } = row?.original || {};
  const labelMap = {
    Sent: {
      label: 'Sent',
      borderColor: 'transparent',
    },
    Accepted: {
      label: 'Accepted',
      color: 'pastel-2-dark',
      bg: 'pastel-2-light',
      borderColor: 'transparent',
    },
    Pending: {
      label: 'Pending',
      color: '#D98647',
      bg: '#FFF0E0',
      borderColor: 'transparent',
    },
    Rejected: {
      label: 'Rejected',
      color: 'pastel-1-dark',
      bg: 'pastel-1-light',
      borderColor: 'transparent',
    },
    Cancelled: {
      label: 'Cancelled',
      color: 'pastel-1-dark',
      bg: 'pastel-1-light',
      borderColor: 'transparent',
    },
  };
  const { label, color, bg } = labelMap[offer_status] || {};
  return <KTag bg={bg} color={color} value={label || '-'}></KTag>;
};

export const Jobname = (row) => {
  const { ats_job = {} } = row?.original || {};
  const { name, id: jobId } = ats_job || {};
  return (
    <Link href={`/jobs/${jobId}`} target="_blank" w="100%">
      <KText
        maxW="100%"
        enableTooltip={true}
        isTruncated
        size="sm-regular"
        _hover={{
          textDecoration: 'underline',
          color: 'primary-500',
          cursor: 'pointer',
        }}
      >
        {name || '-'}
      </KText>
    </Link>
  );
};

export const DepartmentName = (row) => {
  const { ats_department = {} } = row?.original || {};
  const { name } = ats_department || {};
  return (
    <Flex w="100%">
      <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
        {name || '-'}
      </KText>
    </Flex>
  );
};

export const OfficeName = (row) => {
  const { ats_office = {} } = row?.original || {};
  const { name } = ats_office || {};
  return (
    <Flex w="100%">
      <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
        {name || '-'}
      </KText>
    </Flex>
  );
};

export const OfferRevision = (row) => {
  const { revisions_on_data = 0 } = row?.original || {};
  return (
    <Flex w="100%">
      <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
        {revisions_on_data || '-'}
      </KText>
    </Flex>
  );
};

export const TimeToCloseOffer = (row) => {
  const { time_to_close_offer = 0 } = row?.original || {};

  return <KText>{secondsToHumanTime(time_to_close_offer)}</KText>;
};

export const OfferCreatedBy = (row) => {
  const { offer_created_by } = row?.original ?? {};
  const name =
    typeof offer_created_by === 'object' && offer_created_by?.name
      ? offer_created_by.name
      : typeof offer_created_by === 'string'
        ? offer_created_by
        : '';
  const avatar =
    typeof offer_created_by === 'object' ? offer_created_by?.avatar : undefined;

  return (
    <>
      {name ? (
        <Flex w="100%" alignItems="center" gap="6px">
          <KImage
            name={name}
            src={avatar}
            backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
          />
          <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
            {name}
          </KText>
        </Flex>
      ) : (
        '-'
      )}
    </>
  );
};

export const AssociatedRequisition = (row) => {
  const { requisition_code } = row?.original ?? {};
  const code =
    typeof requisition_code === 'object'
      ? (requisition_code?.code ?? '')
      : (requisition_code ?? '');
  const roleName =
    typeof requisition_code === 'object'
      ? (requisition_code?.role_name ?? '')
      : '';
  const label = [code, roleName].filter(Boolean).join(' - ') || '-';
  const reqId = requisition_code?.id || '';

  return (
    <Link href={`/requisitions?view=${reqId}`} target="_blank">
      <KText
        maxW="100%"
        enableTooltip={true}
        isTruncated
        size="sm-regular"
        _hover={{
          textDecoration: 'underline',
          color: 'primary-500',
          cursor: 'pointer',
        }}
      >
        {label}
      </KText>
    </Link>
  );
};
